<template>
  <!-- 路由编辑页面 -->
  <div class="container">
    <div class="el-form" v-loading="loading">
      <el-form :model="form" ref="form" :rules="rule">
        <el-form-item
          label="期刊文章ID: "
          v-show="detailId"
          :label-width="formLabelWidth"
        >
          <el-col :span="20">
            <el-input
              v-model="detailId"
              :disabled="detailId != ''"
              autocomplete="off"
              width="120px"
              placeholder="请输入"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="置顶顺序: " prop="sort" :label-width="formLabelWidth">
          <el-col :span="20">
            <el-input
              v-model="form.sort"
              :disabled="isView"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              maxlength="4"
              autocomplete="off"
              placeholder="请输入置顶顺序,数值小的在最上面,最小值为1,默认9999"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="文章名称: "
          prop="title"
          :label-width="formLabelWidth"
        >
          <el-col :span="20">
            <el-input
              v-model="form.title"
              :disabled="isView"
              :maxlength="maxlength"
              show-word-limit
              autocomplete="off"
              placeholder="请输入文章名称"
            />
          </el-col>
        </el-form-item>
        <el-form-item
          label="期刊ID: "
          prop="journalId"
          :label-width="formLabelWidth"
        >
          <el-col :span="20">
            <el-input
              v-model="form.journalId"
              :disabled="isView"
              @change="handleClazzType"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              maxlength="9"
              autocomplete="off"
              placeholder="请输入期刊ID"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="作者: " prop="author" :label-width="formLabelWidth">
          <el-col :span="20">
            <el-input
              v-model="form.author"
              :disabled="isView"
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入作者名称"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="PDF上传:"
          class="div-upload-form-item address"
          :label-width="formLabelWidth"
        >
          <el-col :span="6">
            <el-upload
              class="upload-demo"
              accept=".PDF"
              :action="PDFAction"
              :headers="headers"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="handlePDFSuccess"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-col>
        </el-form-item>
        <el-form-item label="期刊类别: " prop="clazz" :label-width="formLabelWidth">
          <el-col :span="10">
            <el-radio-group v-model="form.clazz" @change="changeSelect" :disabled="isView">
              <el-radio :label="'1'" >辞书研究</el-radio>
              <el-radio :label="'4'">中国辞书学报 </el-radio>
            </el-radio-group>

            <div style="margin-left:0" v-if="form.clazz=='1'">
              <label style="display:inline-block;margin-top:10px;margin-right: 28px; font-size: 14px" for
                >年份:</label
              >
               <el-date-picker
                v-model="form.journalYear"
                :disabled="isView"
                type="year"
                value-format="yyyy"
                :picker-options="startTime"
                placeholder="选择年">
              </el-date-picker>
              <br>

              <label style="display:inline-block;margin-top:10px;margin-right: 28px;font-size: 14px" for
                >期数:</label
              >
              <el-select
                v-model="form.journalNumber"
                placeholder="全部"
                style="width: 120px"
                :disabled="isView"
              >
                <el-option
                  v-for="(item, index) in numberList"

                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </div>
          </el-col>
        </el-form-item>
      </el-form>
      <!-- 修改状态: 0 已发布, 1 未发布 -->
      <div slot="footer" class="dialog-button" v-if="detailId">
        <el-button type="primary" v-show="isView" @click="$router.push('/dictionary-magazine')">
          返回列表
        </el-button>
        <el-button type="primary" class="confirm-button" :disabled="isView" @click="handelConfirm('form', 0)">
          发 布
        </el-button>
        <el-button class="confirm-button" :disabled="isView" @click="handelConfirm('form', 1)"
          >保 存</el-button
        >
      </div>
      <div slot="footer" class="dialog-button" v-else>
        <el-button type="primary" @click="handelConfirm('form', 0)">
          立即创建
        </el-button>
        <el-button class="confirm-button" @click="resetForm('form')"
          >重 置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Net from '@/constants'
import dictionaryResearchApi from '@/api/dictionaryResearch'
import { mapRequestActions } from '@/utils'
import { getToken } from '@/utils/auth'
import encryption from '@/utils/encryption.js'
export default {
  data () {
    return {
      loading: false,
      formLabelWidth: '150px',
      maxlength: 200,
      isView: !!this.$route.query.isView || false, // 判断预览
      detailId: this.$route.query.id || '',
      detailList: {},
      fileList: [],
      sendFile: [],
      yearList: [],
      numberList: [],
      PdfId: '', // 上传PDFID
      PDFAction: Net.baseUrl + '/common/upload',
      headers: {
        Authorization: 'CsxhBearer ' + getToken()
      },
      form: {
        title: '', // '期刊名称'
        sort: '',
        author: '',
        journalId: '',
        journalYear: '',
        journalNumber: '',
        clazz: ''
      },
      startTime: {
        disabledDate: time => {
          if (this.form.journalYear) {
            return (
              time.getTime() > new Date(this.form.journalYear).getTime()// 这里的this.params.endData按自己的字段参数来
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      rule: {
        title: [
          { required: true, message: '请输入文章名称', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    if (this.detailId) {
      this.handleQueryDetailById()
    }
    this.handleSelectMagazine()
  },
  methods: {
    ...mapRequestActions(dictionaryResearchApi),
    handelConfirm (formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newArr = Object.assign(this.form, {
            fileId: this.PdfId,
            status: type
          })
          // 编辑状态 且 点击发布
          if (this.detailId && type === 0) {
            this.updateMagazineDicResearchAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('编辑成功！')
                this.$router.push('/dictionary-magazine')
              } else {
                this.$message.error('操作失败')
              }
            })
          } else if (this.detailId && type === 1) {
            // 编辑状态 且 点击保存
            this.updateMagazineDicResearchAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('保存成功！')
                this.$router.push('/dictionary-magazine')
              } else {
                this.$message.error('操作失败')
              }
            })
          } else {
            this.addMagazineDicResearchAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('新增成功！')
                this.$router.push('/dictionary-magazine')
              } else {
                this.$message.error('操作失败')
              }
            })
          }
        } else {
          // todo
        }
      })
    },

    /**
     * 根据ID 查询详情
     */
    async handleQueryDetailById () {
      const resultData = await this.getMagazineResearchByIdAction({
        id: this.detailId
      })
      if (resultData.status) {
        const otherForm = Object.assign(resultData.result)
        this.form = otherForm
        this.form.clazz = otherForm.clazz + ''
        if (resultData.result.file) {
          this.fileList.push({
            name: this.form.title,
            url:
            Net.baseUrl + resultData.result.file.relativePath ||
            ''
          })
        }
      }
    },
    /**
     * 根据期刊ID查询相应的clazz类型
     */
    async  handleClazzType () {
      const result = await this.queryDicResearchDetailByIDAction({ id: this.form.journalId })
      if (result.status) {
        this.form.clazz = result.result.clazz + '' || ''
      }
    },
    /**
     * 重置
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
      // this.$refs.uploadfiles1.clearFiles()
      this.fileList = []
      this.form.journalYear = ''
      this.form.journalNumber = ''
    },

    /**
     * 获取下拉筛选 年/期 状态
     */
    async handleSelectMagazine () {
      const resultData = await this.getSelectMagazineAction()
      if (resultData.status) {
        this.yearList = resultData.result.yearList || []
        this.numberList = resultData.result.numberList || []
      }
    },
    /**
     * handleRefresh 强制checkbox-group刷新
     */
    handleRefresh () {
      this.$forceUpdate()
    },

    /**
     * PDF上传成功之后返回视频地址
     */
    handlePDFSuccess (res, file) {
      const result = JSON.parse(encryption.decrypt('w!c_@y(0^sz-xd=h', res))
      this.form.videoUrl1 = Net.baseUrl + result.relativePath
      this.form.url = Net.baseUrl + result.relativePath
      this.PdfId = result.id || ''
    },

    handlePictureCardPreview (file) {
      // console.log('file', file)
    },
    beforeRemove () {},
    handleRemove (e) {
      // 判断是否是删除，因为添加时也走该方法，若isRemove为true时则走该方法
      if (!this.isRemove) {
      } else {
        const index = this.fileList.findIndex((item) => {
          return e.uid === item.uid
        })
        this.fileList.splice(index, 1)
        this.sendFile.splice(index, 1)
      }
    },
    changeSelect (e) {},
    handleChange () {},

    handleBefore (file) {
      this.isRemove = false
      const read = new FileReader()
      read.readAsDataURL(file)

      const that = this
      that.sendFile = []
      that.fileList = []
      that.sendFile.push(file)
      read.onload = function (e) {
        const data = e.target.result
        const image = new Image()
        image.onload = () => {
          const src = e.target.result
          that.fileList.push({ name: file.name, url: src })
          that.isRemove = true
        }
        var formData = new FormData()
        that.sendFile.forEach((element) => {
          formData.append('file', element)
        })
        formData.append('bizeType', '品牌辞书')
        that.upLoadDataAction(formData).then((res) => {
          if (res.status) {
            that.imageId = res.result.id || ''
            // that.linkUrl = res.result.thumbnailUrl || ''
          }
        })
        image.src = data
        // this.$refs.uploadfiles1.clearFiles()
      }
      return false
    },

    handleExceed () {
      this.$message.warning('最多可以上传1份PDF文件')
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
}
.el-form {
  max-width: 90%;
  min-width: 800px;
  margin-right: auto;
  padding: 20px 10px 20px 30px;
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 125px;
    height: 125px;
  }
  // .address {
  //   /deep/ .el-form-item__label:before {
  //     content: "*" !important;
  //     color: #f56c6c !important;
  //     margin-right: 4px !important;
  //   }
  // }
}
.div-upload-form-item {
  position: relative;
  .div-upload-bottom {
    position: absolute;
    right: 0;
    top: 100px;
  }
  .div-upload-container {
    display: block;
    height: 135px;
    float: left;
    overflow: hidden;
    transition: height 0.75s;
    /deep/ .el-upload {
      width: 125px;
      height: 125px;
      line-height: 125px;
    }
  }
}

.el-upload-dragger .el-icon-upload {
  margin: 25px 0 16px;
}
.dialog-button {
  text-align: left;
  margin-left: 20%;
  margin-top: 40px;
  .confirm-button {
    margin-left: 30px;
  }
}
.select_button {
  float: left;
}
.el-col-6 {
  text-align: left;
  padding: 2px 0;
}

/deep/ .input_style {
  display: inline-block;
  padding-left: 4px;
  text-indent: 2px;
  width: 100px;
}
.el-col{
  text-align: left;
}
</style>
